import React, { useEffect, useState } from 'react';
import BaseballMatchBroadcastStore from './store';
import { useParams } from 'react-router-dom';
import { Wrap, Tab, TabButton, ListItem, List } from './styled';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';

const BaseballBroadCast = observer(({ gameData }) => {
  const { gameStatus } = gameData;
  const { detail } = gameData;
  const { period } = detail;
  let { id } = useParams();
  const {
    getBroadcast,
    data,
    closeSocket,
    updateGameStatus
  } = BaseballMatchBroadcastStore();

  const { getPeriodBroadcast, selectedPeriod } = data;
  useEffect(() => {
    getBroadcast(id);
    return () => {
      closeSocket();
    };
  }, []);

  const handleChangePeriod = (period) => {
    data.setSelectedPeriod(period);
  };

  useEffect(() => {
    if (gameStatus) {
      updateGameStatus(gameStatus);
    }
  }, [gameStatus]);

  return (
    <Wrap>
      <Tab>
        <div>
          <TabButton
            active={selectedPeriod === 0}
            onClick={() => handleChangePeriod(0)}
            disabled={false}
          >
            전체
          </TabButton>
          <TabButton
            active={selectedPeriod === 1}
            onClick={() => handleChangePeriod(1)}
            disabled={period < 1}
          >
            1회
          </TabButton>
          <TabButton
            active={selectedPeriod === 2}
            onClick={() => handleChangePeriod(2)}
            disabled={period < 2}
          >
            2회
          </TabButton>
          <TabButton
            active={selectedPeriod === 3}
            onClick={() => handleChangePeriod(3)}
            disabled={period < 3}
          >
            3회
          </TabButton>
          <TabButton
            active={selectedPeriod === 4}
            onClick={() => handleChangePeriod(4)}
            disabled={period < 4}
          >
            4회
          </TabButton>
          <TabButton
            active={selectedPeriod === 5}
            onClick={() => handleChangePeriod(5)}
            disabled={period < 5}
          >
            5회
          </TabButton>
          <TabButton
            active={selectedPeriod === 6}
            onClick={() => handleChangePeriod(6)}
            disabled={period < 6}
          >
            6회
          </TabButton>
          <TabButton
            active={selectedPeriod === 7}
            onClick={() => handleChangePeriod(7)}
            disabled={period < 7}
          >
            7회
          </TabButton>
          <TabButton
            active={selectedPeriod === 8}
            onClick={() => handleChangePeriod(8)}
            disabled={period < 8}
          >
            8회
          </TabButton>
          <TabButton
            active={selectedPeriod === 9}
            onClick={() => handleChangePeriod(9)}
            disabled={period < 9}
          >
            9회
          </TabButton>
          <TabButton
            active={selectedPeriod === 10}
            onClick={() => handleChangePeriod(10)}
            disabled={period < 10}
          >
            연장
          </TabButton>
        </div>
      </Tab>
      <List>
        {getPeriodBroadcast.map((value, key) => {
          return (
            <ListItem key={key}>
              <strong>{value.title}</strong>
              {value.eventTexts.map((value, key) => {
                return <span key={key}>{value.playText}</span>;
              })}
            </ListItem>
          );
        })}
      </List>
    </Wrap>
  );
});

export default BaseballBroadCast;
